import React from "react";
import Hazmat_class_1_1 from "../../../assets/images/DOT_hazmat_class_1.1.svg";
import Hazmat_class_1_2 from "../../../assets/images/DOT_hazmat_class_1.2.svg";
import Hazmat_class_1_3 from "../../../assets/images/DOT_hazmat_class_1.3.svg";
import Hazmat_class_1_4 from "../../../assets/images/DOT_hazmat_class_1.4.svg";
import Hazmat_class_1_5 from "../../../assets/images/DOT_hazmat_class_1.5.svg";
import Hazmat_class_1_6 from "../../../assets/images/DOT_hazmat_class_1.6.svg";

import Hazmat_class_2_1 from "../../../assets/images/DOT_hazmat_class_2.1.svg";
import Hazmat_class_2_2 from "../../../assets/images/DOT_hazmat_class_2.2.svg";
import Hazmat_class_2_3 from "../../../assets/images/DOT_hazmat_class_2.3.svg";

import Hazmat_class_3 from "../../../assets/images/DOT_hazmat_class_3.svg";

import Hazmat_class_4_1 from "../../../assets/images/DOT_hazmat_class_4.1.svg";
import Hazmat_class_4_2 from "../../../assets/images/DOT_hazmat_class_4.2.svg";
import Hazmat_class_4_3 from "../../../assets/images/DOT_hazmat_class_4.3.svg";

import Hazmat_class_5_1 from "../../../assets/images/DOT_hazmat_class_5.1.svg";
import Hazmat_class_5_2 from "../../../assets/images/DOT_hazmat_class_5.2.svg";

import Hazmat_class_6_1 from "../../../assets/images/DOT_hazmat_class_6.1.svg";
import Hazmat_class_6_2 from "../../../assets/images/DOT_hazmat_class_6.2.svg";

import Hazmat_class_7 from "../../../assets/images/DOT_hazmat_class_7.svg";
import Hazmat_class_8 from "../../../assets/images/DOT_hazmat_class_8.svg";
import Hazmat_class_9 from "../../../assets/images/DOT_hazmat_class_9.svg";

const svgMap = {
  1: Hazmat_class_1_1,
  1.1: Hazmat_class_1_1,
  1.2: Hazmat_class_1_2,
  1.3: Hazmat_class_1_3,
  1.4: Hazmat_class_1_4,
  1.5: Hazmat_class_1_5,
  1.6: Hazmat_class_1_6,
  2: Hazmat_class_2_1,
  2.1: Hazmat_class_2_1,
  2.2: Hazmat_class_2_2,
  2.3: Hazmat_class_2_3,
  3: Hazmat_class_3,
  4: Hazmat_class_4_1,
  4.1: Hazmat_class_4_1,
  4.2: Hazmat_class_4_2,
  4.3: Hazmat_class_4_3,
  5: Hazmat_class_5_1,
  5.1: Hazmat_class_5_1,
  5.2: Hazmat_class_5_2,
  6: Hazmat_class_6_1,
  6.1: Hazmat_class_6_1,
  6.2: Hazmat_class_6_2,
  7: Hazmat_class_7,
  8: Hazmat_class_8,
  9: Hazmat_class_9,

  Explosives: Hazmat_class_1_1,
  Gases: Hazmat_class_2_1,
  "Flammable Liquids": Hazmat_class_3,
  "Flammable Solids": Hazmat_class_4_1,
  "Oxidizing Substances and Organic Peroxides": Hazmat_class_5_1,
  "Toxic and Infectious Substances": Hazmat_class_6_1,
  "Radioactive Material": Hazmat_class_7,
  Corrosives: Hazmat_class_8,
  "Miscellaneous Dangerous Goods": Hazmat_class_9,

  "Mass explosion hazard": Hazmat_class_1_1,
  "Projection hazard": Hazmat_class_1_2,
  "Fire hazard and minor blast/projection hazard": Hazmat_class_1_3,
  "No significant hazard": Hazmat_class_1_4,
  "Very insensitive, mass explosion hazard": Hazmat_class_1_5,
  "Extremely insensitive, no mass explosion hazard": Hazmat_class_1_6,

  "Flammable gases": Hazmat_class_2_1,
  "Non-flammable, non-toxic gases": Hazmat_class_2_2,
  "Toxic gases": Hazmat_class_2_3,

  "Flammable liquids": Hazmat_class_3,

  "Flammable solids, self-reactive substances, desensitized explosives":
    Hazmat_class_4_1,
  "Substances liable to spontaneous combustion": Hazmat_class_4_2,
  "Substances which in contact with water emit flammable gases":
    Hazmat_class_4_3,

  "Oxidizing substances": Hazmat_class_5_1,
  "Organic peroxides": Hazmat_class_5_2,

  "Toxic substances": Hazmat_class_6_1,
  "Infectious substances": Hazmat_class_6_2,

  "Radioactive material": Hazmat_class_7,
  "Corrosive substances": Hazmat_class_8,
  "Miscellaneous dangerous substances and articles": Hazmat_class_9,

  default: Hazmat_class_1_1,
};

const getSvg = (key) => svgMap[key] || svgMap.default;

const HazmatImg = ({ hazmatClass }) => {
  const imgSrc = getSvg(hazmatClass);
  return (
    <img
      src={imgSrc}
      alt={`Hazmat Class ${hazmatClass}`}
      style={{ width: 20, height: 20 }}
    />
  );
};

export default HazmatImg;
